export default __webpack_public_path__ + "static/media/8-1.b48c90ec.gif";